import { chevronDownIcon } from '@treasury/presentation/assets/icons';
import '@vaadin/grid';
import { GridColumnBodyLitRenderer, columnBodyRenderer } from '@vaadin/grid/lit.js';
import '@vaadin/grid/vaadin-grid-column.js';
import '@vaadin/grid/vaadin-grid-sort-column.js';
import { html } from 'lit';
import { BalanceReportItemVm, DateRangeBalanceReportItem } from './balance-report-item.vm';

const renderOpenAndCollectedBalanceColumn = (data: DateRangeBalanceReportItem) => {
    return html`<div class="flex flex-col items-end">
        <div class="flex justify-end">
            <div class="text-xs secondary mr-1">Opening</div>
            <div class="text-sm">${data.openingBalance}</div>
        </div>
        <div class="flex justify-center">
            <div class="text-xs secondary mr-1">Collected</div>
            <div class="text-sm">${data.collectedBalance}</div>
        </div>
    </div>`;
};

const renderAccountNameAndNumber = (item: BalanceReportItemVm) => {
    return html`<div>
            <span class="font-medium">${item.accountName}</span
            ><span class="secondary font-light">&nbsp;(${item.accountNumber})</span>
        </div>
        <vaadin-grid all-rows-visible .items=${item.data}>
            <vaadin-grid-sort-column
                path="date"
                flex-grow="0"
                width="8rem"
            ></vaadin-grid-sort-column>
            <vaadin-grid-column
                text-align="end"
                flex-grow="1"
                header="Balance"
                ${columnBodyRenderer(
                    renderOpenAndCollectedBalanceColumn as unknown as GridColumnBodyLitRenderer<DateRangeBalanceReportItem>
                )}
            ></vaadin-grid-column>
        </vaadin-grid>`;
};

const renderAccountColumn = (item: BalanceReportItemVm) => {
    return html`<div
        class="flex flex-col justify-start"
        @click=${(e: CustomEvent) => {
            e.target?.dispatchEvent(
                new CustomEvent('balance-account-clicked', {
                    detail: item,
                    bubbles: true,
                    composed: true,
                })
            );
        }}
    >
        <div class="text-sm font-medium">${item.accountName}</div>
    </div>`;
};

const renderBalanceColumn = (item: BalanceReportItemVm) => {
    return html`<div
        class="flex items-center justify-end"
        @click=${(e: CustomEvent) => {
            e.target?.dispatchEvent(
                new CustomEvent('balance-account-clicked', {
                    detail: item,
                    bubbles: true,
                    composed: true,
                })
            );
        }}
    >
        <div class="flex flex-col">
            <div class="text-sm font-medium">${item.availableBalance}</div>
            <div class="text-xs text-secondary">Available</div>
        </div>
        <tm-icon class="ml-2" .icon=${chevronDownIcon}></tm-icon>
    </div>`;
};

export const renderAccountBalanceRecordDetails = (record: BalanceReportItemVm) => {
    return html`<div class="flex justify-between py-3">
        <div class="flex flex-col">
            <div class="flex flex-col">
                <span class="text-sm">${record.accountNumber}</span>
                <span class="text-xs text-secondary">Number</span>
            </div>
            <div class="flex flex-col">
                <span class="text-sm">${record.accountType}</span
                ><span class="text-xs text-secondary">Type</span>
            </div>
        </div>
        <div class="flex flex-col">
            <div class="flex flex-col">
                <span class="text-sm">${record.currentBalance}</span
                ><span class="text-xs text-secondary">Current Balance</span>
            </div>
            <div class="flex flex-col">
                <span class="text-sm">${record.collectedBalance}</span
                ><span class="text-xs text-secondary">Collected Balance</span>
            </div>
        </div>
    </div>`;
};

export const balanceReportColumns = (records: BalanceReportItemVm[]) => {
    if (records[0]?.isDateRange) {
        return html`<vaadin-grid-column
            ${columnBodyRenderer(
                renderAccountNameAndNumber as GridColumnBodyLitRenderer<BalanceReportItemVm>
            )}
        ></vaadin-grid-column>`;
    }
    if (screen.width < 1024) {
        return html`<vaadin-grid-column
                ${columnBodyRenderer(
                    renderAccountColumn as GridColumnBodyLitRenderer<BalanceReportItemVm>
                )}
            ></vaadin-grid-column
            ><vaadin-grid-column
                text-align="end"
                ${columnBodyRenderer(
                    renderBalanceColumn as GridColumnBodyLitRenderer<BalanceReportItemVm>
                )}
            ></vaadin-grid-column>`;
    }
    return html`<vaadin-grid-sort-column path="accountNumber"></vaadin-grid-sort-column>
        <vaadin-grid-sort-column path="accountName"></vaadin-grid-sort-column>
        <vaadin-grid-sort-column path="accountType"></vaadin-grid-sort-column>
        <vaadin-grid-sort-column path="currentBalance"></vaadin-grid-sort-column>
        <vaadin-grid-sort-column path="availableBalance"></vaadin-grid-sort-column>
        <vaadin-grid-sort-column path="collectedBalance"></vaadin-grid-sort-column>`;
};
